export default "__VITE_ASSET__CuauXoGj__"